<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f7fa;
}

#app {
  min-height: 100vh;
}

/* 通用样式 */
.page-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.card-container {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #303133;
}

.card-subtitle {
  font-size: 14px;
  color: #909399;
  margin-bottom: 16px;
}

/* 统计卡片 */
.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
}

/* 表格样式 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
}

/* 按钮样式 */
.el-button {
  border-radius: 6px;
}

/* 导航样式 */
.nav-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.nav-tab {
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
  background: #fff;
  border: 1px solid #dcdfe6;
}

.nav-tab:hover {
  border-color: #409eff;
  color: #409eff;
}

.nav-tab.active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

/* 来源标签 */
.source-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.source-tag.active {
  background: #409eff;
  color: #fff;
}

/* 状态标签 */
.status-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
}

.status-pending {
  background: #e6a23c;
  color: #fff;
}

.status-processing {
  background: #409eff;
  color: #fff;
}

.status-completed {
  background: #67c23a;
  color: #fff;
}

.status-cancelled {
  background: #909399;
  color: #fff;
}
</style>
